"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DarkSearchCameraIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DarkSearchCameraIcon = function DarkSearchCameraIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "172",
    height: "105",
    viewBox: "0 0 172 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_6184_87655)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M77.5 79.5C97.1061 79.5 113 63.6061 113 44C113 24.3939 97.1061 8.5 77.5 8.5C57.8939 8.5 42 24.3939 42 44C42 63.6061 57.8939 79.5 77.5 79.5Z",
    fill: "#13131C",
    fillOpacity: "0.2",
    stroke: "#EEEEF3",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M77.5 72.5C93.2401 72.5 106 59.7401 106 44C106 28.2599 93.2401 15.5 77.5 15.5C61.7599 15.5 49 28.2599 49 44C49 59.7401 61.7599 72.5 77.5 72.5Z",
    stroke: "#121216",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M129 95.5L103 69.5",
    stroke: "#EEEEF3",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "150.5",
    cy: "44",
    r: "2.5",
    stroke: "#505054",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "169.5",
    cy: "44",
    r: "2",
    fill: "#505054",
    stroke: "#505054"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "2.5",
    cy: "44",
    r: "2",
    fill: "#505054",
    stroke: "#505054"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "21.5",
    cy: "44",
    r: "2.5",
    fill: "#121216",
    stroke: "#505054",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_6184_87655"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "104",
    height: "104",
    fill: "white",
    transform: "translate(34 0.5)"
  }))));
};
exports.DarkSearchCameraIcon = DarkSearchCameraIcon;